import ApiService from '../../../services/ApiService'

export default {
  name: 'ReferralComplete',

  data: () => ({
    loadingCreator: true,
    loading: false,
    invalid: false,
    submitted: false,
    creator: {},
    apiService: new ApiService(),
    form: {
      referredName: null,
      referredCompany: null,
      referredEmail: null,
      referredPhone: null,
    },
  }),

  created() {
    this.loadCreator()
  },

  methods: {
    async loadCreator() {
      const token = this.$route.params.token

      await this.apiService
        .get(`ReferralLink/${token}`)
        .then((response) => {
          this.creator = response.content || {}
        })
        .catch(() => {
          this.invalid = true
        })
        .finally(() => {
          this.loadingCreator = false
        })
    },

    async submit() {
      if (!this.$refs.completeForm.validate()) return

      this.loading = true
      const token = this.$route.params.token

      await this.apiService
        .post(`ReferralLink/complete/${token}`, this.form)
        .then(() => {
          this.submitted = true
        })
        .catch((err) => {
          this.$toast.error(err?.body?.message || 'Erro ao enviar dados. Tente novamente.')
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
